module.exports = __webpack_public_path__ + "img/male1.121cb940.png";